import React, { PropsWithChildren, ReactElement, useContext } from 'react';

import { LogDataFormGroupProps, UnitNode } from '../../components';
import { CouponMold, ProductCouponMold } from '../../editorComponents/Coupon/type';

interface ExhibitionInfo {
  startAt?: string;
  endAt?: string;
}

export interface CouponContextValue {
  exhibitionInfo?: ExhibitionInfo;
  /**
   * 장바구니 쿠폰틀을 조회합니다.
   * @param ids 조회할 쿠폰틀 id들
   * @return 조회된 쿠폰틀 데이터들
   */
  getCoupons?: (ids: string[]) => Promise<CouponMold[]> | CouponMold[];
  /**
   * 상품 쿠폰틀을 조회합니다.
   * @param ids 조회할 상품 쿠폰틀 id들
   * @returns 조회된 상품 쿠폰틀 데이터들
   */
  getProductCoupons?: (ids: string[]) => Promise<ProductCouponMold[]> | ProductCouponMold[];
  /**
   * 쿠폰 click시 실행되는 event입니다. 주로 쿠폰 발급시 사용합니다.
   * @param cartCouponMoldIds 발급할 장바구니 쿠폰 id들
   * @param productCouponMoldIds 발급할 상품 쿠폰 id들
   */
  onClick?: (cartCouponMoldIds: string[], productCouponMoldIds: string[]) => Promise<void> | void;
  /** 로그 데이터를 custom할 때 사용합니다. */
  setLogData?: (unitNode: UnitNode) => LogDataFormGroupProps;
}

const CouponContext = React.createContext<CouponContextValue>({});
export const useCouponContext = (): CouponContextValue => useContext(CouponContext);

export function CouponContextProvider({
  children,
  value = {},
}: PropsWithChildren<{ value?: CouponContextValue }>): ReactElement {
  return (
    <CouponContext.Provider value={value}>{ children }</CouponContext.Provider>
  );
}
